import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { api } from "./api";

let registered = false;

export async function registerPushNotifications() {
  if (!Capacitor.isNativePlatform()) return; // no-op on web
  if (registered) return;
  registered = true;

  try {
    const perm = await PushNotifications.requestPermissions();
    if (perm.receive !== "granted") return;

    await PushNotifications.register();

    PushNotifications.addListener("registration", async (token) => {
      try {
        await api.post("/users/me/fcm-token", { token: token.value });
      } catch (e) {
        console.warn("Failed to register push token:", e);
      }
    });

    PushNotifications.addListener("registrationError", (err) => {
      console.warn("Push registration error:", err);
    });

    // Foreground notification received — the OS won't show a banner while
    // the app is open, so this is where you'd surface an in-app toast if desired.
    PushNotifications.addListener("pushNotificationReceived", (notification) => {
      console.log("Push received in foreground:", notification);
    });

    // User tapped a notification (app was backgrounded or closed)
    PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
      console.log("Push tapped:", action.notification);
    });
  } catch (e) {
    console.warn("Push notifications setup failed:", e);
  }
}
